import { ref } from "vue"
import Tr from "@/translations"

/**
 * Articulos de una categoria del catalogo, resueltos por slug.
 *
 * Un 404 del backend (slug inexistente o idioma no sembrado) NO se trata como
 * error de carga: se deja la lista vacia y el componente pinta el mismo bloque
 * que cuando la categoria existe pero no tiene articulos vigentes. Expulsar al
 * usuario desde una URL que casi acierta es peor que ofrecerle el catalogo.
 */
const getArticlesFromCategory = () => {

    const articles = ref([])
    const error = ref(null)
    const isLoading = ref(false)

    const load = async (categorySlug) => {
        isLoading.value = true
        error.value = null

        try {
            const url = process.env.VUE_APP_ROOT_API + "articles/by-category/"
                + encodeURIComponent(categorySlug) + "/" + Tr.currentLocale

            const response = await fetch(url)
            const data = await response.json()

            if (data.error || Number(data.code) !== 200) {
                articles.value = []
                error.value = { code: Number(data.code) || response.status, message: data.message }
                return
            }

            articles.value = data.results || []
        } catch (err) {
            articles.value = []
            // code 0 = no hubo respuesta del servidor
            error.value = { code: 0, message: err.message }
        } finally {
            isLoading.value = false
        }
    }

    return { articles, error, isLoading, load }
}

export default getArticlesFromCategory
